module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon10.a5f8f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/introduceBTypeBIcon10.png
// module id = GElT
// module chunks = 0